import * as React from "react";
import * as dayjs from "dayjs";
// Configuration file for national model result page
// Chart.js Plot config for overall trend plot
export const nationalResultOptions = (plotQueryProps) => {
    return {
        type: 'line',
            responsive: true,
        elements: {
        point:{
            radius: 1
        }
    },
        plugins: {
            legend: {
                position: "right" as const,
            },
            title: {
                fullSize: true,
                    font: {
                    size: 20
                },
                display: true,
                    text: "Infrastructure Australia - Market Capacity Report (Plant/Labour/Equipment/Material view)",
            }
        },
        scales: {
            x: {
                ticks: {
                    callback: function(value) {
                        // "this" is accessing the chart context when it gets applied
                        // @ts-ignore
                        let label = dayjs(this.getLabelForValue(value), "DD/MM/YYYY").month()

                        if (label == 0){
                            // For each month of the year we get a callback. This check will  only plot the single month per year
                            // @ts-ignore
                            return dayjs(this.getLabelForValue(value)).format("YYYY")
                        }
                    }
                },
                grid: {
                    display: false,
                        drawTicks: false,
                }
            },
            y: {
                stacked: true,
                ticks: {
                    maxTicksLimit: 5,
                    callback: function (value) {
                        return (plotQueryProps.unit == 'Value' ? '$' : '') + (value / 1000000).toLocaleString() + "M";
                        // The .toLocaleString() method adds a comma separator for thousands.
                    }
                },
            }
        }
    }
}

//Configuration list for National the plot filters
export const nationalFilterConfigList = [
    {
        name: "Super sector",
        propID: "inSuperSectorID",
        listName: "executeGetSuperSectorsList",
        valueKey: "SuperSectorID",
        valueName: "SuperSector",
        defaultValue: 0
    },
    {
        name: "Master type",
        propID: "inMasterTypeID",
        listName: "executeGetMasterTypesList",
        valueKey: "MasterTypeID",
        valueName: "MasterType",
        defaultValue: 0
    },
    {
        name: "Project type",
        propID: "inProjectTypeID",
        listName: "executeGetRawProjectTypes",
        valueKey: "RawProjectTypeID",
        valueName: "RawProjectType",
        multiple: true,
        defaultValue: 0
    },
    {
        name: "MPIP",
        propID: "inInfraFlag",
        listName: "executeGetInfraFlagsList",
        valueKey: "InfraFlag",
        valueName: "InfraFlag",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Plant/Labour/Equipment/Material",
        propID: "inPLEMGroupID",
        listName: "executeGetPLEMTypesList",
        valueKey: "PLEMGroupID",
        valueName: "PLEMGroup",
        defaultValue: 0
    },
    {
        name: "Level 1 group",
        propID: "inLevel1GroupID",
        listName: "executeGetL1GroupList",
        valueKey: "Lvl1GroupID",
        valueName: "Lvl1Group",
        defaultValue: 0
    },
    {
        name: "Resource group",
        propID: "inResourceGroupID",
        listName: "executeGetResourceGroupsList",
        valueKey: "ResourceGroupID",
        valueName: "ResourceGroup",
        multiple: true,
        defaultValue: 0
    },
];
